import { Endpoints } from "../../../constants/endpoints";
import client from "../../client";
import { TRegisterUser, TGoogleSignInBody } from "./types";

export const postGoogleSignUp = async (payload: TGoogleSignInBody) => {
  const { data } = await client.post<TGoogleSignInBody, TRegisterUser>(
    Endpoints.postGoogleSignUp,
    {
      ...payload,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
